/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState, useEffect } from "react"
import Nav from "../nav/nav"
import "./layout.scss"
import Header from '../../molecules/header/header';
import useChangeTheme from '../../../shared/hooks/useChangeTheme';
import Footer from '../../molecules/footer/footer';
import GlobalContext from '../../../contexts/globalContext';
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import Headboard from "../headboard/headboard";
import useDirectionScroll from "../../../shared/hooks/useDirectionScroll";
import HeadboardTabs from "../headboard-tabs/headboardTabs";
import HeadboardButtons from "../headboard-buttons/headboardButtons";
import HeadboardSimple from "../headboard-simple/headboardSimple";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useVerifyChat from '../../../hooks/useVerifyChat';
import useLoginGigya from '../../../shared/hooks/useLoginGigya';
import { useStaticQuery, graphql } from "gatsby";
import FloatingButton from "../../atoms/floating-button/floatingButton";

interface LayoutInterface {
   children: any;
   headboard?:ReferenciaCabecera;
   isNotRoot?:boolean;
   hideHeaderDesktop:boolean;
   hideHeaderMobile:boolean;
   typeChat?:string;
}

const Layout = (props: LayoutInterface) => {
   const [isMenuActive, setMenuActive] = useState(false);
   const [isSearcherActive, setSearcherActive] = useState(false);
   const [_scrollActive, setScrollActive] = useState(false);
   const [size, setSize] = useState(0);
   const [_superFooter, setSuperFooter] = useState<boolean>(false);
   const [isDark, changeDarkMode] = useChangeTheme();
   const { lastDirection, resetDirection } = useDirectionScroll();
   const { isBrowser, localStorage, document, window } = useBrowserMode();
   const { verifyChat } = useVerifyChat();
   const gigyaContext = useLoginGigya();
   
   const data = useStaticQuery(graphql`
      query BUTTON_ICON {
         allContentfulAsset(filter: {title: {eq: "centro-de-atencion"}}) {
            nodes {
               file {
                  url
               }
            }
         }
      }
   `);

   useEffect( () => {
      if( isBrowser ) {
         const realSize = parseInt( localStorage.getItem('font-size') || '100' );
         const item = document.querySelector('html') || { style: {fontSize:realSize} };
         item.style.fontSize = `${realSize}%`;
         setSize(realSize);
         toLocalStoragepageActive();
      }
      isBrowser && document.addEventListener('scroll', onScrollAction);
      props.typeChat && verifyChat(props.typeChat);
      return () => {
         isBrowser && document.removeEventListener('scroll', onScrollAction);
      }
   }, [])

   const doSetSize = ( _size:number ) => {
      localStorage.setItem('font-size', `${_size}`);
      setSize(_size);
   }

   const toLocalStoragepageActive = () => {
      if (localStorage.getItem('Redirection')) {
         const storage: any = localStorage.getItem('Redirection')
         const data = JSON.parse(storage)
         if (data.titleButton === 'COMFAMA.COM') {
            return false;
         } else {
            return localStorage.setItem('Redirection', JSON.stringify({ 'titleButton': 'COMFAMA.COM', 'path': '' }))
         }
      } else {
         return localStorage.setItem('Redirection', JSON.stringify({ 'titleButton': 'COMFAMA.COM', 'path': '' }))
      }
   }

   const scrollActive = { get: _scrollActive, set: setScrollActive }

   const context = {
      fontSize: { get: size, set: doSetSize },
      superFooter: { get: _superFooter, set: setSuperFooter },
      gigyaContext: { ...gigyaContext }
   }

   let timerScroll:any;

   const onScrollAction = () => {
      window.clearTimeout( timerScroll );
      timerScroll = setTimeout(() => {
         if(window.pageYOffset < 70) {
            resetDirection()
         }
      }, 66);
   }

   const switchHeadBoard = (headboard:ReferenciaCabecera, superFooter) => {
      switch ( headboard.tipoCabecera ) {
         case 'CabeceraPrincipal': 
            return <Headboard {...headboard} />
         case 'CabeceraTabs' :
            return <HeadboardTabs superFooter={superFooter} {...headboard} />
         case 'CabeceraBotones':
            return <HeadboardButtons superFooter={superFooter}  {...headboard} />
         case 'CabeceraSimple':
            return <HeadboardSimple {...headboard} />
         default :
            return <Headboard {...headboard} />
      }
   }

   return (
      <GlobalContext.Provider value={context} >
         {/* <Header siteTitle={data.site.siteMetadata.title} /> */}
         <Header
            isNotRoot={props.isNotRoot}  
            scrollActive={scrollActive} 
            isMenuActive={isMenuActive}
            isSearcherActive={isSearcherActive}
            setMenuActive={setMenuActive}
            setSearcherActive={setSearcherActive}
            isDark={isDark} 
            actionTheme={changeDarkMode} 
            lastDirection={lastDirection}
            hideHeaderDesktop={props.hideHeaderDesktop}
            hideHeaderMobile={props.hideHeaderMobile}
         />
         <Nav 
            isMenuActive={isMenuActive} 
            isSearcherActive={isSearcherActive}
            isDark={isDark} 
            actionTheme={changeDarkMode} 
         />
         <div>
            { props.headboard && switchHeadBoard(props.headboard, context.superFooter) }
            <main>{props.children}</main>
         </div>
         <FloatingButton
            url='https://comfamavirtual.sistemasentry.com.co/VisionWeb'
            icon={data.allContentfulAsset.nodes[0].file.url}
         />
         <Footer isSuperFooter={_superFooter} />
      </GlobalContext.Provider>
   )
}

export default Layout;
